var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPopUp(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 59,
    height: 59,
    viewBox: "0 0 59 59",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "pop-up 1"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer 51"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M16.5938 36.8751V19.8389H11.0625C9.59687 19.8432 8.19251 20.4274 7.15615 21.4638C6.11979 22.5001 5.53563 23.9045 5.53125 25.3701V47.9376C5.53563 49.4033 6.11979 50.8076 7.15615 51.844C8.19251 52.8803 9.59687 53.4645 11.0625 53.4689H33.63C35.0956 53.4645 36.5 52.8803 37.5364 51.844C38.5727 50.8076 39.1569 49.4033 39.1613 47.9376V42.4064H22.125C20.6594 42.402 19.255 41.8178 18.2187 40.7815C17.1823 39.7451 16.5981 38.3408 16.5938 36.8751Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M47.9376 5.53125H25.3701C23.9045 5.53563 22.5001 6.11979 21.4638 7.15615C20.4274 8.19251 19.8432 9.59687 19.8389 11.0625V33.63C19.8432 35.0956 20.4274 36.5 21.4638 37.5364C22.5001 38.5727 23.9045 39.1569 25.3701 39.1613H47.9376C49.4032 39.1569 50.8076 38.5727 51.844 37.5364C52.8803 36.5 53.4645 35.0956 53.4689 33.63V11.0625C53.4645 9.59687 52.8803 8.19251 51.844 7.15615C50.8076 6.11979 49.4032 5.53563 47.9376 5.53125ZM47.9376 22.125C47.9376 22.614 47.7434 23.083 47.3976 23.4287C47.0518 23.7745 46.5829 23.9688 46.0939 23.9688C45.6049 23.9688 45.1359 23.7745 44.7901 23.4287C44.4444 23.083 44.2501 22.614 44.2501 22.125V14.75H36.8751C36.3861 14.75 35.9172 14.5557 35.5714 14.21C35.2256 13.8642 35.0314 13.3952 35.0314 12.9063C35.0314 12.4173 35.2256 11.9483 35.5714 11.6025C35.9172 11.2568 36.3861 11.0625 36.8751 11.0625H44.2501C45.2281 11.0625 46.166 11.451 46.8576 12.1425C47.5491 12.8341 47.9376 13.772 47.9376 14.75V22.125Z",
    fill: "white"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPopUp);
export default __webpack_public_path__ + "static/media/pop-up.254d01f6b3578b4bc183b573cc257017.svg";
export { ForwardRef as ReactComponent };